import _ from 'lodash';

const getFormikError = ({ field = {}, form = {} }) => {
  const { errors = {} } = form;
  const { name = '' } = field;
  return _.get(errors, name);
};

export default getFormikError;
